import { jsx as _jsx } from "react/jsx-runtime";
import { SelectField } from "../select-field";
/**
 * A formik field for gender selection.
 *
 * @param {Props} props The props for the component.
 * @returns {JSX.Element} The rendered gender field component.
 */
export const GenderField = ({ label, name, disabled = false }) => (_jsx(SelectField, { disabled: disabled, getOptionLabel: option => option, getOptionValue: option => option.toUpperCase(), label: label, name: name, options: Object.values(GENDERS) }));
export var GENDERS;
(function (GENDERS) {
    GENDERS["MALE"] = "Male";
    GENDERS["FEMALE"] = "Female";
    GENDERS["UNKNOWN"] = "Unknown";
})(GENDERS || (GENDERS = {}));
